export default "__VITE_ASSET__ChQ_tI_p__"